var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-page',{attrs:{"hideTopNav":true}},[_c('div',{staticClass:"separation-anxiety-exercise"},[_c('separation-anxiety-exercise-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }